import type { Selfie } from "lib/hooks/useSelfie";

export default function checkViewerHasFlag(viewer: Selfie, key: string) {
  return viewer?.featureFlags.some(({ flag, value }) => flag.key === key && value);
}
